import React, {useEffect, useState} from 'react';
import {Button, ButtonTier, ButtonType, Card, Colors, InputField, Loader, SaveButton, SelectField} from '../components';
import Image from '../components/Image';
import {useAppStore} from '../data/AppStore';
import {isValidEmail, logger} from '../utilities';
import CustomerService from '../api/customerService';
import ActionflowService from "../api/actionflowService";
import {initalLocations} from '../constants';
import {loadPreviousCart} from '../helpers/loadPreviousCart';
import {ArrowRightIcon} from '@radix-ui/react-icons'

import './ClientInfo.scss';
import {useNavigate} from "react-router-dom";
import {shallow} from "zustand/shallow";
import StoneAppService from "../api/stoneAppService";

const LOG_PREFIX = '[ClientInfo.js]';

const ClientInfo = (props) => {
    const [state, _setState] = useState({
        location: false,
        locations: [],
        name: '',
        email: '',
        job: '',
        syncing: false,
        syncingCallback: null,
        account: '',
    });
    const setState = (newState) => _setState(Object.assign({}, state, newState));
    const {location, locations, name, email, job, syncing, syncingCallback, account} = state;
    const {checkout} = props;
    const [COMPANY, CART, OFFERINGS, OFFLINE, PREVIOUS_CLIENT] = useAppStore(
        (state) => [
            state.COMPANY,
            state.CART,
            state.OFFERINGS,
            state.OFFLINE,
            state.PREVIOUS_CLIENT
        ], shallow
    )
    const [clearUSER, setCLIENT, setPREVIOUS_CLIENT, setCART, hydrateUSER] = useAppStore(
        (state) => [
            state.clearUSER,
            state.setCLIENT,
            state.setPREVIOUS_CLIENT,
            state.setCART,
            state.hydrateUSER,
        ], shallow)

    const logo = COMPANY && COMPANY.settings && COMPANY.settings.logo_url ? COMPANY.settings.logo_url : null;
    useEffect(() => {
        if (COMPANY) {
            fetchLocations();
        }
    }, [COMPANY]);
    useEffect(() => {
        if (syncing) {
            syncingCallback();
        }
    }, [syncing])
    const navigate = useNavigate();

    const fetchLocations = () => {
        logger.debug(LOG_PREFIX, '.fetchLocations()', {props, state});
        if (!COMPANY.settings) {
            return;
        }
        let locations = (COMPANY.settings.json_data &&
            COMPANY.settings.json_data['locations'] &&
            (COMPANY.settings.json_data['locations'].length > 0)) ? COMPANY.settings.json_data['locations'] : initalLocations;
        locations = locations.sort();
        locations.push('Other');
        setState({locations: [...new Set(locations)]});
    }

    const getActionFlow = () => {
        logger.debug(LOG_PREFIX, '.getActionFlow()', {props, state});
        if (!syncing && job) {
            setState({
                syncing: true, syncingCallback: async () => {
                    try {
                        const res = await ActionflowService.getJob(COMPANY.actionflow, job);
                        debugger;
                        logger.debug(LOG_PREFIX, '.getActionFlow()', {res});
                        setState({
                            syncing: false,
                            name: res.CustomerName,
                            syncingCallback: null,
                            email: (res.JobSiteEmails && res.JobSiteEmails.length > 0) ? res.JobSiteEmails[0].EmailAddress : '',
                        });
                    } catch (error) {
                        logger.debug(LOG_PREFIX, '.getActionFlow()', {error});
                        setState({syncing: false, syncingCallback: null});
                    }
                }
            });
        }
    }
    const getStoneApp = () => {
        logger.debug(LOG_PREFIX, '.getStoneApp()', {props, state});
        if (!syncing && job) {
            setState({
                syncing: true, syncingCallback: async () => {
                    try {
                        debugger;
                        const res = await StoneAppService.getJob(COMPANY.stoneApp, job);
                        debugger;
                        logger.debug(LOG_PREFIX, '.getStoneApp()', {res});
                        setState({
                            syncing: false,
                            name: (res.JobContactList && res.JobContactList.length > 0) ? res.JobContactList[0]['Name'] : '',
                            syncingCallback: null,
                            email: (res.JobContactList && res.JobContactList.length > 0) ? res.JobContactList[0]['Email'] : '',
                        });
                    } catch (error) {
                        logger.debug(LOG_PREFIX, '.getStoneApp()', {error});
                        setState({syncing: false, syncingCallback: null});
                    }
                }
            });
        }
    }
    const getMoraware = async () => {
        logger.debug(LOG_PREFIX, '.getMoraware()', {props, state});
        if (!syncing && job) {
            setState({
                syncing: true, syncingCallback: async () => {
                    try {
                        const {Job, Account} = await CustomerService.getMorawareData(job);
                        let newName, newAccount, newEmail;

                        if (Job.Address.ContactName) {
                            newName = Job.Address.ContactName;
                        }
                        if (Job.Address.Email) {
                            newEmail = Job.Address.Email.toLowerCase();
                        }

                        let found = Account.CustomFieldValues.find((cfv) => {
                            return cfv.CustomFieldTypeName === (COMPANY.settings.json_data['account_map'] || 'Account Type');
                        });

                        if (found) {
                            const accountsList = COMPANY.settings.json_data['accounts']
                            const accounts = Object.keys(accountsList).length ? Object.keys(accountsList) : ['Default Account'];
                            newAccount = accounts.find((a) => a === found.FieldValue);
                        }
                        setState({syncing: false, name: newName, email: newEmail, account: newAccount});
                    } catch (error) {
                        setState({syncing: false});
                    }
                }
            });
        }
    }

    const handleContinueClick = async (redirect = true, skipStatements = false) => {
        logger.debug(LOG_PREFIX, '.handleContinueClick()', {props, state});
        setCLIENT({name, email, account, job, location});
        setPREVIOUS_CLIENT({name, email, account, job, location});
        if (!OFFLINE) {
            const loadedCart = await loadPreviousCart(CART, COMPANY, {name, email, account, job, location});
            if (loadedCart) {
                setCART(loadedCart);
            }
        }
        if (redirect === true) {
            if ((skipStatements && OFFERINGS.length > 0) || (COMPANY.settings.mission_statement === 'n/a' && COMPANY.settings.thank_you_statement === 'n/a')) {
                navigate(`/offering/${OFFERINGS[0].id}`, {replace: true});
            } else {
                navigate('/mission', {replace: true});
            }
        }
    }

    const handleInputKeyPress = (e) => {
        // if (e.which === 13 && isValid()) {
        //   this.handleContinueClick(this.props.cart === undefined);
        // }
    }

    const isValid = account && job && name && email && location && isValidEmail(email);

    const buildSelection = () => {
        logger.debug(LOG_PREFIX, '.buildSelection()', {props, state});
        let selected = null;
        if (account) {
            selected = {label: account, value: account};
        }
        const accountsList = COMPANY.settings.json_data['accounts']
        const selectFields = Object.keys(accountsList).length ? Object.keys(accountsList) : ['Default Account'];
        return (
            <SelectField
                label={'Account'}
                options={selectFields.map((x) => {
                    return {value: x, label: x};
                })}
                value={(account) ? selected : null}
                placeholder={'Select account'}
                onChange={(e) => {
                    let account = e.value;
                    setState({account});
                }}
            />
        );
    }

    return (
        <section className='ClientInfo'>
            {(COMPANY && Object.keys(COMPANY).length > 0) ?
                <>
                    <Image src={logo} fallbackSrc={null} alt={`${COMPANY.name || 'loading'} logo`}
                           className={'logo small'}/>
                    <div>
                        <Card colorTheme={Colors.Orange}>
                            <form className='clientInfo' onSubmit={(e) => {
                                e.preventDefault();
                                handleContinueClick(true);
                            }}>
                                {!CART.accepted.length > 0 ? // check
                                    <p className={'Label'}>Enter Customer Info Below:</p>
                                    :
                                    <p className={'Label'}>Enter Customer info below to finalize the approval of
                                        offerings purchase</p>
                                }

                                <div>
                                    <InputField
                                        label={'Job ID/#'}
                                        placeholder={'If none, write "none"'}
                                        onKeyPress={handleInputKeyPress}
                                        onChange={(e) => setState({job: e})}
                                        onClearIconClick={() => setState({job: "none"})}
                                        value={job}
                                    />
                                </div>

                                {COMPANY && COMPANY.moraware && COMPANY.moraware.url && !OFFLINE && (
                                    <div>
                                        <Button
                                            className={'synchButton'}
                                            type={ButtonType.Download}
                                            colorTheme={Colors.Orange}
                                            label={'Sync With Moraware'}
                                            onClick={getMoraware}
                                            disabled={!job || job === 'none' || syncing}
                                            tier={ButtonTier.Secondary}
                                        />
                                    </div>
                                )}

                                {COMPANY && COMPANY.actionflow && !OFFLINE && (
                                    <div>
                                        <Button
                                            className={'synchButton'}
                                            type={ButtonType.Download}
                                            colorTheme={Colors.Orange}
                                            label={'Sync With ActionFlow'}
                                            onClick={getActionFlow}
                                            disabled={!job || job === 'none' || syncing}
                                            tier={ButtonTier.Secondary}
                                        />
                                    </div>
                                )}

                                {COMPANY && COMPANY.stoneApp && !OFFLINE && (
                                    <div>
                                        <Button
                                            className={'synchButton'}
                                            type={ButtonType.Download}
                                            colorTheme={Colors.Orange}
                                            label={'Sync With StoneApp'}
                                            onClick={getStoneApp}
                                            disabled={!job || job === 'none' || syncing}
                                            tier={ButtonTier.Secondary}
                                        />
                                    </div>
                                )}

                                {buildSelection()}

                                <SelectField
                                    creatable={true}
                                    label={'Location'}
                                    options={locations.map((x) => {
                                        return {value: x, label: x};
                                    })}
                                    value={(location) ? {value: location, label: location} : null}
                                    placeholder={'Select Location or type to create custom'}
                                    onChange={(e) => {
                                        let location = e.value;
                                        setState({location});
                                    }}
                                />

                                <div>
                                    <InputField
                                        label={'Name'}
                                        placeholder={'Customer Name'}
                                        onKeyPress={handleInputKeyPress}
                                        onChange={(e) => setState({name: e})}
                                        onClearIconClick={() => setState({name: ""})}
                                        value={name}
                                    />
                                </div>

                                <div>
                                    <InputField
                                        label={'Email'}
                                        placeholder={'Customer Email'}
                                        className={'vertical-layout'}
                                        onKeyPress={handleInputKeyPress}
                                        onChange={(e) => setState({email: e.toLowerCase()})}
                                        onClearIconClick={() => setState({email: ""})}
                                        value={email}
                                    />
                                </div>

                                <div className={'buttonRow'}>

                                    <Button
                                        label={'Previous Customer'}
                                        onClick={() => {
                                            let {name, email, account, job, location} = PREVIOUS_CLIENT;
                                            setState({name, email, account, job, location});
                                        }}
                                        disabled={!PREVIOUS_CLIENT || Object.values(PREVIOUS_CLIENT).length <= 0}
                                        type={ButtonType.Reset}
                                        colorTheme={Colors.Sage}
                                        tier={ButtonTier.Secondary}
                                    />

                                    {((COMPANY.settings && COMPANY.settings.mission_statement !== 'n/a' && COMPANY.settings.thank_you_statement !== 'n/a')) ?
                                        <Button
                                            label={'Skip Statements'}
                                            onClick={() => {
                                                handleContinueClick(true, true);
                                            }}
                                            tier={ButtonTier.Tertiary}
                                            disabled={!isValid || (OFFERINGS && OFFERINGS.length <= 0)}
                                        />
                                        : <div/>
                                    }

                                    {CART.accepted.length > 0 ?
                                        <Button
                                            label={'Finalize'}
                                            type={ButtonType.Save}
                                            colorTheme={Colors.Orange}
                                            onClick={() => {
                                                handleContinueClick(false, checkout);
                                            }}
                                            disabled={!isValid}
                                        />
                                        :
                                        <Button
                                            label={'Continue'}
                                            form={true}
                                            type={ButtonType.Forward}
                                            colorTheme={Colors.Orange}
                                            disabled={!isValid}
                                        />
                                    }
                                </div>

                            </form>
                        </Card>
                    </div>
                </>
                :
                <>
                    <div/>
                    <div>
                        <Loader label={'loading company data'}/>
                    </div>
                </>
            }

            <div>
                <a href={'https://www.hotsauceyourtops.com/learning'} target={'_blank'} rel="noreferrer">
                    <div className={'learningCenter'}>
                        Hot Sauce Learning Center <ArrowRightIcon/>
                    </div>
                </a>
            </div>

            <div className={'buttonWrapper'}>
                <Button
                    className={'LogoutButton'}
                    label={'Logout'}
                    onClick={clearUSER}
                    type={ButtonType.Logout}
                    tier={ButtonTier.Secondary}
                    colorTheme={Colors.Red}
                />
                <SaveButton
                    label={'Refresh App Data'}
                    className={'RefreshButton'}
                    type={ButtonType.Update}
                    colorTheme={Colors.Orange}
                    onClick={hydrateUSER}
                />
                <Button
                    label={'My Dashboard'}
                    className={'NavButton'}
                    onClick={() => navigate('/commission', {replace: true})}
                    type={ButtonType.Dashboard}
                    colorTheme={Colors.Sage}
                />
            </div>

        </section>
    );
}


export default ClientInfo;